function i(n = 8) {
  return Math.random().toString(16).slice(2, 2 + n);
}
function o(n, e) {
  const r = [];
  for (let t = 0; t < n; ++t)
    r.push(e);
  return r;
}
function u(n, e) {
  const r = [];
  if (!e) {
    for (let t = 0; t < n; ++t)
      r.push(t);
    return r;
  }
  for (let t = 0; t < n; ++t)
    r.push(e(t));
  return r;
}
export {
  i as createId,
  u as indexMap,
  o as repeat
};
